/* globals request */
import API_URL_MAP from '../configs/url-api';

export default class Videosesesion {
  static checkAvailabilityVideosession(videosessionId) {
    const url = `${API_URL_MAP.VIDEOSESSION}/${videosessionId}${API_URL_MAP.CHECK_AVAILABILITY}`;
    return request(url, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  static acceptInviteVideosession(videosessionId) {
    const url = `${API_URL_MAP.VIDEOSESSION}/${videosessionId}${API_URL_MAP.INVITE_ACCEPT}`;
    return request(url, {
      method: 'POST',
      auth: 'Bearer',
    });
  }

  static cancelInviteVideosession(videosessionId, userId) {
    const body = {
      user: `${userId}`,
    };
    const url = `${API_URL_MAP.VIDEOSESSION}/${videosessionId}${API_URL_MAP.INVITE_CANCEL}`;
    return request(url, {
      method: 'POST',
      auth: 'Bearer',
      body,
    });
  }
}
